/**
 * History Page Route
 * Dedicated page for viewing all invoice history
 */

import { createFileRoute } from '@tanstack/react-router';
import { HistoryPage } from '@/components/history/HistoryPage';
import { SEOHead } from '@/components/seo/SEOHead';

export const Route = createFileRoute('/history')({
  component: () => (
    <>
      <SEOHead
        title="Invoice History - Smart Invoice Generator"
        description="View and manage your invoice history. Access all your previously created invoices, track payments, and download past invoices anytime."
        keywords="invoice history, invoice tracking, past invoices, invoice management, invoice records"
        canonical="https://invoicegenerated.com/history"
      />
      <HistoryPage />
    </>
  ),
});
